// extracted by mini-css-extract-plugin
export default {"noData":"SkillCategoryBarChart_noData__DDG-B"};